import type { RouteInfoWithAttributes } from '@ember/routing/route-info';
import type RouteInfo from '@ember/routing/route-info';

/**
 * Extract dynamic route parameters from the route info object.
 * @returns An array of dynamic route parameters.
 */
export default function extractRouteParams(routeInfo: RouteInfo | RouteInfoWithAttributes): string[] {
  const params: string[] = [];

  // Walk up the route hierarchy to collect all dynamic segments
  let currentRoute: RouteInfo | RouteInfoWithAttributes | null = routeInfo;
  while (currentRoute) {
    if (currentRoute.params) {
      // Get the route's dynamic segments in order
      const routeParams = <string[]>(
        Object.values(currentRoute.params).filter((param) => param !== null && param !== undefined && param !== '')
      );

      // Prepend to maintain correct order (parent params first)
      params.unshift(...routeParams);
    }
    currentRoute = currentRoute.parent;
  }

  return params;
}
